"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutSelectionFloatingObjectItem = exports.LayoutRangePermissionItem = exports.LayoutSelectionSearchItem = exports.LayoutSelectionMisspelledItem = exports.LayoutSelectionCursorItem = exports.LayoutSelectionItem = void 0;
var tslib_1 = require("tslib");
var rectangle_1 = require("@devexpress/utils/lib/geometry/rectangle");
var renderer_class_names_1 = require("../../canvas/renderer-class-names");
var z_index_helper_1 = require("../../canvas/renderes/z-index-helper");
var point_1 = require("@devexpress/utils/lib/geometry/point");
var LayoutSelectionItem = (function (_super) {
    tslib_1.__extends(LayoutSelectionItem, _super);
    function LayoutSelectionItem() {
        return _super.call(this, 0, 0, 0, 0) || this;
    }
    LayoutSelectionItem.prototype.isCursor = function () {
        return false;
    };
    Object.defineProperty(LayoutSelectionItem.prototype, "zIndexClassType", {
        get: function () {
            return z_index_helper_1.zIndexCssClassType.SelRow;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayoutSelectionItem.prototype, "baseClassName", {
        get: function () {
            return renderer_class_names_1.RendererClassNames.SELECTION_ROW;
        },
        enumerable: false,
        configurable: true
    });
    LayoutSelectionItem.create = function (pos, size, floatingObjectId, constr) {
        var item = new constr();
        item.floatingObjectId = floatingObjectId;
        return item.setPosition(new point_1.Point(pos.pageArea.x + pos.column.x + pos.row.x, pos.pageArea.y + pos.column.y + pos.row.y))
            .setSize(size);
    };
    LayoutSelectionItem.prototype.equals = function (obj) {
        return this.floatingObjectId == obj.floatingObjectId && _super.prototype.equals.call(this, obj);
    };
    LayoutSelectionItem.mainPageAreaSelection = -1;
    LayoutSelectionItem.headerFooterPageAreaSelection = -2;
    return LayoutSelectionItem;
}(rectangle_1.Rectangle));
exports.LayoutSelectionItem = LayoutSelectionItem;
var LayoutSelectionCursorItem = (function (_super) {
    tslib_1.__extends(LayoutSelectionCursorItem, _super);
    function LayoutSelectionCursorItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LayoutSelectionCursorItem.prototype.isCursor = function () {
        return true;
    };
    Object.defineProperty(LayoutSelectionCursorItem.prototype, "zIndexClassType", {
        get: function () {
            return z_index_helper_1.zIndexCssClassType.SelCursor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayoutSelectionCursorItem.prototype, "baseClassName", {
        get: function () {
            return [renderer_class_names_1.RendererClassNames.SELECTION_CURSOR, renderer_class_names_1.RendererClassNames.CURSOR_NO_BLINK_CLASS_NAME].join(" ");
        },
        enumerable: false,
        configurable: true
    });
    return LayoutSelectionCursorItem;
}(LayoutSelectionItem));
exports.LayoutSelectionCursorItem = LayoutSelectionCursorItem;
var LayoutSelectionMisspelledItem = (function (_super) {
    tslib_1.__extends(LayoutSelectionMisspelledItem, _super);
    function LayoutSelectionMisspelledItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(LayoutSelectionMisspelledItem.prototype, "zIndexClassType", {
        get: function () {
            return z_index_helper_1.zIndexCssClassType.SelMissp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayoutSelectionMisspelledItem.prototype, "baseClassName", {
        get: function () {
            return renderer_class_names_1.RendererClassNames.SELECTION_MISSPELLED;
        },
        enumerable: false,
        configurable: true
    });
    return LayoutSelectionMisspelledItem;
}(LayoutSelectionItem));
exports.LayoutSelectionMisspelledItem = LayoutSelectionMisspelledItem;
var LayoutSelectionSearchItem = (function (_super) {
    tslib_1.__extends(LayoutSelectionSearchItem, _super);
    function LayoutSelectionSearchItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(LayoutSelectionSearchItem.prototype, "zIndexClassType", {
        get: function () {
            return z_index_helper_1.zIndexCssClassType.SelSearch;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayoutSelectionSearchItem.prototype, "baseClassName", {
        get: function () {
            return [renderer_class_names_1.RendererClassNames.SELECTION_ROW, renderer_class_names_1.RendererClassNames.SELECTION_SEARCH].join(" ");
        },
        enumerable: false,
        configurable: true
    });
    return LayoutSelectionSearchItem;
}(LayoutSelectionItem));
exports.LayoutSelectionSearchItem = LayoutSelectionSearchItem;
var LayoutRangePermissionItem = (function (_super) {
    tslib_1.__extends(LayoutRangePermissionItem, _super);
    function LayoutRangePermissionItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(LayoutRangePermissionItem.prototype, "zIndexClassType", {
        get: function () {
            return z_index_helper_1.zIndexCssClassType.SelRange;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayoutRangePermissionItem.prototype, "baseClassName", {
        get: function () {
            return renderer_class_names_1.RendererClassNames.SELECTION_RANGE_PERMISSION;
        },
        enumerable: false,
        configurable: true
    });
    LayoutRangePermissionItem.prototype.equals = function (obj) {
        return this.color == obj.color && _super.prototype.equals.call(this, obj);
    };
    return LayoutRangePermissionItem;
}(LayoutSelectionItem));
exports.LayoutRangePermissionItem = LayoutRangePermissionItem;
var LayoutSelectionFloatingObjectItem = (function (_super) {
    tslib_1.__extends(LayoutSelectionFloatingObjectItem, _super);
    function LayoutSelectionFloatingObjectItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(LayoutSelectionFloatingObjectItem.prototype, "zIndexClassType", {
        get: function () {
            return z_index_helper_1.zIndexCssClassType.SelRow;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LayoutSelectionFloatingObjectItem.prototype, "baseClassName", {
        get: function () {
            return [renderer_class_names_1.RendererClassNames.SELECTION_ROW, renderer_class_names_1.RendererClassNames.SELECTION_FLOATING_OBJECTS].join(" ");
        },
        enumerable: false,
        configurable: true
    });
    return LayoutSelectionFloatingObjectItem;
}(LayoutSelectionItem));
exports.LayoutSelectionFloatingObjectItem = LayoutSelectionFloatingObjectItem;
